// extracted by mini-css-extract-plugin
module.exports = {"title":"TitleWithSeparator_title__1RYzh"};